export default {
  title: 'Stav regulátora:',
};
